<h1 mat-dialog-title class="no-margin">DETTAGLIO PROPOSTA PROFILO PROFESSIONALE<mat-icon class="close-icon"
                                                                                         (click)="onNoClick()">close</mat-icon></h1>
<div *ngIf="!data.permessi" class="intestazione"><strong>Profilo
  professionale:</strong><span>&nbsp;{{data.profilo.nomeProfilo}}</span>
</div>
<div class="dialog-body-overflow">
  <div class="content-box">
    <mat-list role="list" *ngIf="!data.permessi">
      <mat-list-item role="listitem"><strong class="caption noFloat">Stato proposta:</strong><span
        class="grey noFloat">{{data.profilo.statoProposta.descrizione}}</span></mat-list-item>
      <mat-list-item matTooltip="{{data.profilo.descrizioneArea.descrizione}}" role="listitem"><strong
        class="caption noFloat">Area:</strong><span
        class="grey noFloat">{{data.profilo.descrizioneArea.descrizione}}</span></mat-list-item>
      <mat-list-item role="listitem" matTooltip="{{data.profilo.descrizioneProfilo}}"><strong
        class="caption noFloat">Descrizione Profilo
        Professionale:</strong><span
        class="grey noFloat">{{data.profilo.descrizioneProfilo}}</span></mat-list-item>
      <mat-list-item role="listitem" matTooltip="{{data.profilo.elementiContesto}}"><strong
        class="caption noFloat">Elementi di Contesto:</strong><span
        class="grey noFloat">{{data.profilo.elementiContesto}}</span></mat-list-item>

    </mat-list>
  </div>
  <mat-list role="list" *ngIf="data.permessi">
    <mat-list-item role="listitem"><strong class="caption noFloat">Stato proposta:</strong><span
      class="grey noFloat">{{data.profilo.statoProposta.descrizione}}</span></mat-list-item>
    <mat-list-item role="listitem"><strong class="caption noFloat">Data Invio proposta:</strong><span
      class="grey noFloat">{{data.profilo.dataInvioProposta | date:'dd/MM/yyyy'}}</span></mat-list-item>
  </mat-list>
  <mat-form-field style="margin-left:10px;" appearance="fill" *ngIf="data.permessi">
    <mat-label>Area professionale</mat-label>
    <mat-select name="descrizioneArea" [compareWith]="compareObjects" [(ngModel)]="data.profilo.descrizioneArea">
      <mat-option *ngFor="let item of listaAree" [value]="item">
        {{item.descrizione}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style="margin-left:10px;" appearance="fill" *ngIf="data.permessi">
    <mat-label>Profilo professionale</mat-label>
    <input matInput placeholder="Placeholder" [value]="data.profilo.nomeProfilo" name="nomeProfilo"
           [(ngModel)]="data.profilo.nomeProfilo">
  </mat-form-field>

  <mat-form-field style="margin-left:10px;" appearance="fill" *ngIf="data.permessi">
    <mat-label>Descrizione profilo professionale</mat-label>
    <textarea rows="5" matInput placeholder="Placeholder 2" [value]="data.profilo.descrizioneProfilo"
              name="descrizioneProfilo" [(ngModel)]="data.profilo.descrizioneProfilo"></textarea>
  </mat-form-field>

  <mat-form-field style="margin-left:10px;" appearance="fill" *ngIf="data.permessi">
    <mat-label>Elementi di contesto</mat-label>
    <textarea rows="5" matInput placeholder="Placeholder 2" [value]="data.profilo.elementiContesto"
              name="elementiContesto" [(ngModel)]="data.profilo.elementiContesto"></textarea>
  </mat-form-field>
  <div class="content-box">
    <mat-list role="list" *ngIf="!data.permessi">
      <mat-list-item role="listitem"><strong class="caption noFloat">Invio proposta:</strong><span
        class="grey noFloat">{{data.profilo.dataInvioProposta | date:'dd/MM/yyyy'}}</span></mat-list-item>
      <mat-list-item role="listitem"><strong class="caption noFloat">Validazione:</strong><span
        class="grey noFloat">{{data.profilo.dataValidazione | date:'dd/MM/yyyy'}}</span></mat-list-item>
      <mat-list-item role="listitem"><strong class="caption noFloat">Approvazione:</strong><span
        class="grey noFloat">{{data.profilo.dataApprovazione | date:'dd/MM/yyyy'}}</span></mat-list-item>
      <mat-list-item role="listitem" matTooltip="{{data.profilo.motivazioniProposta}}"><strong
        class="caption noFloat">Motivazioni relative all'inserimento della
        Proposta:</strong><span
        class="grey noFloat">{{data.profilo.motivazioniProposta}}</span></mat-list-item>
    </mat-list>

  </div>
  <h4 class="sectionTitle">REFERENZIAZIONI <mat-icon class="edit_icon" (click)="apriReferenziazioni()" *ngIf="data.permessi">edit</mat-icon>
  </h4>
  <hr class="dividerLine">
  <mat-list role="list">
    <mat-list-item role="listitem"><strong class="caption left">Livello Eqf:</strong><span
      class="grey">&nbsp;{{data.profilo.livelloEqf}}</span></mat-list-item>
  </mat-list>
  <mat-list role="list" *ngIf="listaAda && listaAda.length>0">
    <mat-list-item role="listitem"><strong class="caption">Ada:</strong>
      <span class="grey noFloat" *ngFor="let codice of listaAda">
                <svg height="12" width="12">
                    <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                </svg>
        {{codice.codiceAda}} - {{codice.descrizione}}
            </span>
    </mat-list-item>
  </mat-list>
  <mat-list role="list" *ngIf="listaAteco && listaAteco.length>0">
    <mat-list-item role="listitem"><strong class="caption">Ateco:</strong>
      <span class="grey noFloat" *ngFor="let codice of listaAteco">
                <svg height="12" width="12">
                    <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                </svg>
        {{codice.codiceAteco}} - {{codice.descrizione}}</span>
    </mat-list-item>
  </mat-list>
  <mat-list role="list" *ngIf="listaIsco && listaIsco.length>0">
    <mat-list-item role="listitem"><strong class="caption">Isco:</strong>
      <span class="grey noFloat" *ngFor="let codice of listaIsco">
                <svg height="12" width="12">
                    <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                </svg>
        {{codice.codiceIsco}} - {{codice.descrizione}}</span>
    </mat-list-item>
  </mat-list>
  <mat-list role="list" *ngIf="listaIstat && listaIstat.length>0">
    <mat-list-item role="listitem"><strong class="caption">Istat:</strong>
      <span class="grey noFloat" *ngFor="let codice of listaIstat">
                <svg height="12" width="12">
                    <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                </svg>
        {{codice.codiceIstat}} - {{codice.nome}}</span>
    </mat-list-item>
  </mat-list>
  <h4 class="sectionTitle">LISTA COMPETENZE <mat-icon class="edit_icon" (click)="apriCompetenze()" *ngIf="data.permessi">edit</mat-icon>
  </h4>
  <hr class="dividerLine">
  <div *ngIf="listaCompetenze && listaCompetenze.length>0">
    <mat-list role="list" *ngFor="let competenza of listaCompetenze">
      <mat-list-item role="listitem" class="listeProposta light-green"><strong
        class="caption">{{competenza.descrizione}}</strong></mat-list-item>

      <mat-list-item role="listitem" class="listeProposta"><span class="grey"><strong class="left">Livello
                        Eqf:</strong>&nbsp;{{competenza.eqfCompetenza}}</span><br />
        <div *ngIf="competenza.listaConoscenze && competenza.listaConoscenze.length>0">
          <span class="grey noFloat margin-top-15"><strong class="left">Conoscenze:</strong></span>

          <span class="grey noFloat" *ngFor="let conoscenza of competenza.listaConoscenze">
                        <svg height="12" width="12">
                            <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                        </svg>
            {{conoscenza.descrizione}}</span>

        </div>
        <div *ngIf="competenza.listaAbilita && competenza.listaAbilita.length>0">
          <span class="grey noFloat margin-top-15"><strong class="left">Abilità:</strong></span>
          <span class="grey noFloat" *ngFor="let abilita of competenza.listaAbilita">
                        <svg height="12" width="12">
                            <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                        </svg>
            {{abilita.descrizione}}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
</div>


<div mat-dialog-actions class="actions">

  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Annulla
  </button>
  <button *ngIf="data.permessi" mat-fab extended class="searchbox-buttons save-button" (click)="salva()">
    <mat-icon>save</mat-icon>Salva
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" (click)="reportProfiloProfessionalePdf()"
          *ngIf="this.pdfVisible">
    <mat-icon>picture_as_pdf</mat-icon>{{data.profilo.testoPulsanteStampaPdf}}
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" (click)="reportProfiloProfessionaleXls()"
          *ngIf="this.xlsVisible">
    <mat-icon>download</mat-icon>{{data.profilo.testoPulsanteStampaXls}}
  </button>


</div>
